import api, { ensureCsrfCookie } from "../axiosConfig";

export async function listLines(params = {}) {
  await ensureCsrfCookie();
  const { data } = await api.get("/omnichannel/whatsapp-lines", { params });
  return data.data;
}

export async function createLine(payload) {
  await ensureCsrfCookie();
  const { data } = await api.post("/omnichannel/whatsapp-lines", payload);
  return data.data;
}

export async function updateLine(lineId, payload) {
  await ensureCsrfCookie();
  const { data } = await api.put(`/omnichannel/whatsapp-lines/${lineId}`, payload);
  return data.data;
}

export async function getMyLine() {
  await ensureCsrfCookie();
  const { data } = await api.get("/users/me/whatsapp-line");
  return data;
}

export async function saveMyLine(payload) {
  await ensureCsrfCookie();
  const { data } = await api.put("/users/me/whatsapp-line", payload);
  return data;
}
